export default function guest({ next, store }) {
    if (localStorage.getItem("authorization") === "true") {
        return next({
            name: "Dashboard"
        });
    }
    if (next.name === "Login" || next.name === "")  return next();
    else next({
        name: "Login"
    })

}
